<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container">
        <div class="modal-body text-center">
          <img
            src="/images/pgx-logo.png"
            alt="pgx-logo"
            width="50"
            class="mb-3"
          />
          <h5 class="modal-title">Aktifkan Two-Factor Authentication</h5>
          <p class="modal-text">
            Untuk keamanan akun Anda, segera aktifkan 2FA agar akun lebih
            terlindungi dari akses yang tidak sah.
          </p>
          <div class="modal-actions">
            <button class="btn btn-gradient" @click="$emit('activate')">
              Aktifkan 2FA
            </button>
            <button class="btn btn-outline-light" @click="$emit('close')">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  width: 100%;
  max-width: 420px;
  margin: 16px;
  padding: 28px 24px;
  background: linear-gradient(180deg, #1a1a2e 0%, #12121f 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

.modal-title {
  color: #fff;
  font-weight: 600;
  margin-bottom: 12px;
}

.modal-text {
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-actions .btn {
  width: 100%;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.96);
}
</style>
